import { styled } from 'styled-components';

import { Media } from '@/js/libs/ui';
import { NAVIGATION_WIDTH, NAVIGATION_WIDTH_COLLAPSED } from '@/js/libs/ui/src/V2/Components/PuzzleNav/constants';

export const Wrapper = styled.div<{ $isCollapsedNav: boolean }>`
  display: flex;
  align-items: flex-start;
  min-height: 100vh;
  @media ${Media.xsMax} {
    overflow: ${({ $isCollapsedNav }) => !$isCollapsedNav && 'hidden'};
    max-height: ${({ $isCollapsedNav }) => !$isCollapsedNav && '100vh'};
  }
`;

export const Content = styled.div<{ $isCollapsedNav: boolean }>`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  @media ${Media.mdMin} {
    padding-bottom: 24px;
  }
  @media ${Media.smMax} {
    padding-bottom: 8px;
  }
  @media ${Media.lgMin} {
    width: calc(100% - ${({ $isCollapsedNav }) => ($isCollapsedNav ? NAVIGATION_WIDTH_COLLAPSED : NAVIGATION_WIDTH)});
  }
  @media ${Media.mdMax} {
    width: 100%;
  }
`;
